// @flow
import React from 'react';
import Tag from '../Tag/Tag';

import type { FilterField } from '../Filter';

export type ProcessType = 'generate' | 'count';

function processTags(type: ProcessType, filterFields: FilterField[],
                     handleDeleteTag?: (name?: string, field?: string) => void,
                     formatMessage?: ({}) => string): Tag[] | number {
  let count = 0;
  const tags = [];
  filterFields.forEach((filterField: FilterField, n: number) => {
    switch (filterField.type) {
      case 'text':
        if (filterField.stateValue && filterField.stateValue.value &&
          typeof filterField.stateValue.value === 'string') {
          if (type === 'count') return count++;
          return tags.push(
            <Tag key={`${n}-${filterField.stateValue.value}`}
                 handleDelete={handleDeleteTag ? handleDeleteTag : _ => undefined}
                 label={filterField.stateValue.value}
                 name={filterField.name}
                 value={filterField.name}/>
          );
        }
        break;
      case 'checkbox':
        if (filterField.stateValue) {
          Object.keys(filterField.stateValue).forEach((checkboxStr: string, n: number) => {
            const foundCheckbox = (filterField: any).checkboxes.find(c => c.value === checkboxStr);
            const checkbox = filterField.name === 'categories' ? parseInt(checkboxStr, 10) : checkboxStr;
            if (type === 'count' && filterField.stateValue && filterField.stateValue[checkboxStr] && foundCheckbox)
              return count++;
            if (formatMessage) {
              return filterField.stateValue && filterField.stateValue[checkboxStr] && foundCheckbox &&
                tags.push(
                  <Tag key={`${n}-${checkbox}`}
                       handleDelete={handleDeleteTag ? handleDeleteTag : _ => undefined}
                       name={filterField.name}
                       value={checkboxStr}
                       label={foundCheckbox.label ? foundCheckbox.label :
                         formatMessage({ id: foundCheckbox.labelIntl })}/>
                );
            }
          });
          break;
        }
      case 'range':
        break;
    }
  });
  if (type === 'count') return count;
  return tags;
}

export function generateTags(filterFields: FilterField[], handleDeleteTag?: (name?: string, field?: string) => void,
                             formatMessage: ({}) => string): ?Tag[] {
  const tags = processTags('generate', filterFields, handleDeleteTag, formatMessage);
  if (tags instanceof Array) return tags;
}

export function countTags(filterFields: FilterField[]): ?number {
  const count = processTags('count', filterFields);
  if (typeof count === 'number') return count;
}




// WEBPACK FOOTER //
// ./src/elements/Filter/utils/index.jsx